import * as React from 'react';

import {
  ActionContainer,
  Container,
  Details,
  DetailsContainer,
  Heading,
  IconContainer,
  NotificationWrapper,
} from './top-service-mode-notification.styled';
import { ITopServiceModeNotificationViewProps } from './types';

export const TopServiceModeNotificationView = ({
  heading,
  icon,
  details,
  cta,
  className = '',
}: ITopServiceModeNotificationViewProps) => {
  return (
    <Container className={className}>
      <NotificationWrapper>
        <IconContainer data-testid="service-notification-icon">{icon}</IconContainer>
        <DetailsContainer>
          {heading && <Heading data-testid="service-notification-heading">{heading}</Heading>}
          {details && <Details data-testid="service-notification-details">{details}</Details>}
        </DetailsContainer>
        <ActionContainer>{cta}</ActionContainer>
      </NotificationWrapper>
    </Container>
  );
};
